import { render, staticRenderFns } from "./NavGroup.htm?vue&type=template&id=4ccdf825&scoped=true&"
import script from "./NavGroup.ts?vue&type=script&lang=js&"
export * from "./NavGroup.ts?vue&type=script&lang=js&"
import style0 from "./NavGroup.scss?vue&type=style&index=0&id=4ccdf825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdf825",
  null
  
)

export default component.exports